export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.d7261533.ttf";